import React from 'react';
import { useComputedValuesOfDriverDayJourney } from 'modules/job-review/detail/computed';
import { Icon } from '@ontruck/orc';

const JourneyList = ({
  className,
  journeys,
  skins,
  showActions,
  actionsDisabled,
  shipperOrderIdsPerJourney,
}) => {
  const computedJourneys = useComputedValuesOfDriverDayJourney(journeys);

  return (
    <div className={className}>
      <div className="container">
        {computedJourneys?.map((journey) => {
          const hasMoreShippers = journey.shipper_names?.length - 1;
          return (
            <div className="journey" key={journey.id}>
              <div className={`skin skin_${skins[journey.id]}`} />
              <div className="journey_id">J{journey.id}</div>
              <div className="shipper">{journey.shipper_company_name}</div>
              {!!hasMoreShippers && (
                <div className="shippers_hidden">+{journey.shipper_names?.length - 1}</div>
              )}
              {showActions && (
                <button
                  className="actions-button"
                  data-tip={JSON.stringify({
                    journeyId: journey?.id,
                    shipperOrderIds: shipperOrderIdsPerJourney[journey?.id],
                  })}
                  data-for="actions-tooltip"
                  data-event="click"
                  disabled={actionsDisabled}
                >
                  <Icon glyph="more-actions" />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JourneyList;
